import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setArea } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, object = logged, false = guest

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, []);

  // o servidor barrou uma chamada por falta de assinatura do contrato: atualiza o estado para abrir a tela de assinatura
  useEffect(() => {
    const h = () => api.get("/auth/me").then((res) => setUser(res.data)).catch(() => {});
    window.addEventListener("contract-pending", h);
    return () => window.removeEventListener("contract-pending", h);
  }, []);

  const login = async (email, password) => {
    setArea("prof");
    const res = await api.post("/auth/login", { email, password });
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    try { localStorage.removeItem("iep-ia-fichas"); } catch (e) {}   // fichas guardadas para o app da Keyla abrir sem internet
    setArea("prof");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
